import React from 'react'
import styles from "./style.module.scss"

interface Props {
   children: any,
   hidePopUp: React.MouseEventHandler<HTMLDivElement>
}

const Popup: React.FC<Props> = ({ children, hidePopUp }) => {

   return (
      <div className={`${styles.main} d-flex`} onClick={hidePopUp}>
         {children}
      </div>
   )
}

export default Popup